export default __webpack_public_path__ + "static/media/imgDark7.1e3bcb82.png";